import type { PortraitViewRow } from "@/lib/characters-api"

export type CharacterThumbnailSource = {
  portrait_views?: PortraitViewRow[]
  portrait_thumb_url?: string | null
  portrait_url?: string | null
  reference_sheet_thumb_url?: string | null
  reference_sheet_url?: string | null
}

export function characterListThumbnail(source: CharacterThumbnailSource): string | null {
  const frontFromViews = source.portrait_views?.find((v) => v.view === "front")
  const portraitThumb = frontFromViews?.thumb_url ?? frontFromViews?.url
  if (portraitThumb) return portraitThumb

  if (source.portrait_thumb_url) return source.portrait_thumb_url
  if (source.portrait_url) return source.portrait_url

  return source.reference_sheet_thumb_url ?? source.reference_sheet_url ?? null
}
